import useDebouncedEditorStateContext from 'hubspot-prosemirror/prosemirror/contexts/useDebouncedEditorStateContext';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import styled from 'styled-components';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { useEffect, useState } from 'react';
import ContentAssistantInlineAutocompleteMenu from './CAAutocompleteMenu';
import { initContentAssistantSlashPluginState } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const OptionsUl = styled.ul.withConfig({
  displayName: "CADropdown__OptionsUl",
  componentId: "sc-12trt35-0"
})(["-webkit-tap-highlight-color:rgba(0,0,0,0);border-radius:inherit;list-style:none;margin:0;max-height:220px;overflow-x:hidden;overflow-y:auto;padding:0;position:relative;"]);
const OptionsLi = styled.li.withConfig({
  displayName: "CADropdown__OptionsLi",
  componentId: "sc-12trt35-1"
})(["padding:8px 12px;&.focus{background-color:", ";}"], BATTLESHIP);
const OptionButton = styled.button.withConfig({
  displayName: "CADropdown__OptionButton",
  componentId: "sc-12trt35-2"
})(["background:none;border:0;color:inherit;padding:0;text-align:inherit;text-transform:inherit;"]);
export default function ContentAssistantDropdown({
  view,
  options,
  pluginKey,
  onInsert,
  getSelectedCommandParams,
  trackInteraction,
  usageDescription
}) {
  const {
    editorState
  } = useDebouncedEditorStateContext();
  const pluginState = pluginKey.getState(editorState) || {};
  const {
    searchTerm,
    currentDropdownIndex,
    popoverActive
  } = pluginState;
  const displayOptions = searchTerm ? Object.keys(options).filter(key => {
    return I18n.text(options[key].labelKey).toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
  }) : Object.keys(options);
  const [selectedOption, setSelectedOption] = useState(null);

  // since the browser focus is still on the editor so user can continue to type
  // have to listen to on Enter event while dropdown is open
  useEffect(() => {
    const keyupListener = e => {
      if (e.key === 'Enter') {
        setSelectedOption(options[displayOptions[currentDropdownIndex]]);
      }
    };
    window.addEventListener('keyup', keyupListener);
    return () => {
      window.removeEventListener('keyup', keyupListener);
    };
  }, [currentDropdownIndex, selectedOption, options, displayOptions]);
  const onSelectCommand = selectedCommand => {
    view.dispatch(view.state.tr.setMeta(pluginKey, Object.assign({}, pluginState, {
      popoverActive: true
    })));
    setSelectedOption(selectedCommand);
  };
  const handleOnMenuClose = () => {
    view.dispatch(view.state.tr.setMeta(pluginKey, initContentAssistantSlashPluginState()));
  };
  const dropdownContent = /*#__PURE__*/_jsx(OptionsUl, {
    "data-test-id": `content-assistant-slash-dropdown-list`,
    children: displayOptions.length ? displayOptions.map((key, index) => {
      return /*#__PURE__*/_jsx(OptionsLi, {
        "data-test-id": `content-assistant-slash-option`,
        className: currentDropdownIndex === index ? "focus" : "",
        children: /*#__PURE__*/_jsx(OptionButton, {
          className: 'truncate-text',
          onClick: onSelectCommand.bind(null, options[key]),
          children: I18n.text(options[key].labelKey)
        })
      }, key);
    }) : /*#__PURE__*/_jsx(OptionsLi, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: 'inlineAutocompleteMenu.noResult'
      })
    })
  });
  const showPopover = popoverActive && selectedOption;
  if (showPopover) {
    return /*#__PURE__*/_jsx(ContentAssistantInlineAutocompleteMenu, {
      onInsert: onInsert,
      onClose: handleOnMenuClose,
      selectedItem: selectedOption,
      view: view,
      state: pluginState,
      getSelectedCommandParams: getSelectedCommandParams,
      trackInteraction: trackInteraction,
      usageDescription: usageDescription,
      pluginKey: pluginKey
    });
  }
  return /*#__PURE__*/_jsx(UIPopover, {
    autoPlacement: true,
    content: dropdownContent,
    open: true,
    placement: "bottom",
    "data-test-id": 'content-assistant-slash-popover',
    children: /*#__PURE__*/_jsx("span", {})
  });
}